import { addToFavorites } from 'containers/Vcard/actions/favorite/favorite.actions';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const useAddToFavoriteFromFreemium = ({ groupId }) => {
    const dispatch = useDispatch();
    const userHasSession = useSelector(state => state?.user?.userhash);
  const favorites = useSelector(state => state?.favorites);
  const isFavorite = favorites?.find(fav => fav?.id === groupId);
  const addContentToFavorite =
  JSON.parse(localStorage.getItem('addToFavorite')) || '';

  useEffect(() => {
    if(isFavorite || !addContentToFavorite) return

    const params = {
        user_hash: userHasSession,
        object_id: groupId,
        object_type: 1,
      };
    dispatch(addToFavorites(params));
  }, []);
};
